import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as accountsReducer from "containers/Accounts/reducer";

import AccountSelector from "components/Accounts/AccountSelector";

class AccountSelectorContainer extends React.PureComponent {
  handleSelect(account) {
    const { onChange, updateSelectedAccount } = this.props;
    if (onChange) {
      return onChange(account);
    } else {
      return updateSelectedAccount(account && account.id);
    }
  }
  render() {
    return <AccountSelector {...this.props} onChange={(account) => this.handleSelect(account)} />;
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateSelectedAccount: (accountId) => dispatch(accountsReducer.handleSelect(accountId))
});

const mapStateToProps = (state, ownProps) => {
  const removeAccountTypes = ownProps.removeAccountTypes;
  let accounts = accountsReducer.getActiveAccounts(state);
  if (removeAccountTypes?.length) {
    accounts = accounts.filter((a) => {
      return removeAccountTypes.includes(a?.type);
    });
  }

  let selectedAccountId = accountsReducer.getSelectedAccountId(state);
  let selectedAccount = accountsReducer.getSelectedAccount(state);
  if (ownProps.value) {
    selectedAccountId = ownProps.value;
    selectedAccount = accountsReducer.getAccount(state, selectedAccountId);
  }
  return {
    accounts: accounts,
    selectedAccount: selectedAccount,
    selectedAccountId: selectedAccountId
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(AccountSelectorContainer);
